import SeoHead from '../components/SeoHead'
import PricingView from '../views/Pricing'
import { useLanguage } from '../i18n/LanguageContext'

const PricingPage = () => {
  const { t } = useLanguage()
  const title = t('seo.pricingTitle')
  const description = t('seo.pricingDescription')

  return (
    <>
      <SeoHead
        title={title}
        description={description}
        path="/pricing"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'SheetMate',
          description,
          offers: [
            {
              '@type': 'Offer',
              name: 'SheetMate Pro Yearly',
              price: '9.9',
              priceCurrency: 'USD'
            },
            {
              '@type': 'Offer',
              name: 'SheetMate Lifetime',
              price: '19.9',
              priceCurrency: 'USD'
            }
          ]
        }}
      />
      <PricingView />
    </>
  )
}

export default PricingPage
